import { OccurrencesModule } from "@/components/rdo/modules/OccurrencesModule";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";

interface OccurrencesForRDOProps {
  legacyValue: any;                 // shape atual usado em RDO.tsx (ocorrências)
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
  // Espelhamento das fotos da ocorrência no container geral de Fotos.
  // Recebe fotos já no formato legado de Fotos (source: "occurrence").
  onMirrorPhotos?: (mirroredLegacyPhotos: any[]) => void;
}

/**
 * Adapter de Ocorrências. O gate (módulo novo vs. seção legada inline) é feito
 * no call-site do RDO.tsx via getFlag("useNewOccurrencesInRDO"); aqui apenas
 * convertemos legado -> unificado, renderizamos o módulo e convertemos de volta.
 *
 * Paridade com o legado: ao adicionar fotos a uma ocorrência (com hidePhotos
 * = false), elas são espelhadas no container geral de Fotos via onMirrorPhotos.
 */
export function OccurrencesForRDO({ legacyValue, onLegacyChange, mode, onMirrorPhotos }: OccurrencesForRDOProps) {
  const rdo = normalizeFromRDOPAGE({
    occurrences: legacyValue || [],
    obraId: "",
    date: "",
    status: "draft",
  });

  return (
    <OccurrencesModule
      value={rdo.occurrences}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(occurrences) => {
        const payload = toRDOPAGEPayload({ ...rdo, occurrences });
        onLegacyChange(payload.occurrences);
      }}
      onMirrorPhotos={(photos, occurrenceIndex) => {
        const mirrored = photos.map((p) => ({
          id: p.id,
          url: p.url,
          caption: p.caption,
          source: "occurrence",
          occurrenceIndex,
          hiddenFromReport: false,
          timestamp: p.createdAt,
        }));
        onMirrorPhotos?.(mirrored);
      }}
    />
  );
}
